import { FacilityAmountsForOneFacilityStatus } from './reducer'

// Formats a facility amount for display: two decimals, thousands separators,
// and a trailing currency code (defaulting to USD when none is set).
export const formatFacilityAmount = (
  value: number,
  currency: string | null | undefined,
): string => {
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
  return `${formatted} ${currency || 'USD'}`
}

// The "Current Facility Amount" disclosure line on the Facility Edit / backdated
// Amendment form (LOS-5287). It is read-only context next to the editable
// as-of-effective-date field, and must never block the form:
//   - creation form (not editing) → hidden entirely (AC9)
//   - amounts still resolving (loading/idle, or status not yet provided) →
//     a non-blocking "Loading…" line, never a stale/zero value (AC6)
//   - load failed → "Unavailable" (AC7)
//   - resolved → the formatted current amount (AC3)
export const currentFacilityAmountDescription = (
  isEditingExistingFacility: boolean,
  status: FacilityAmountsForOneFacilityStatus | undefined,
  formattedAmount: string,
): string | undefined => {
  if (!isEditingExistingFacility) {
    return undefined
  }
  if (status === 'error') {
    return 'Current Facility Amount: Unavailable'
  }
  if (status === 'loading' || status === 'idle' || status === undefined) {
    return 'Current Facility Amount: Loading…'
  }
  return `Current Facility Amount: ${formattedAmount}`
}
